import { render, staticRenderFns } from "./presentation-external-scrub.vue?vue&type=template&id=60f662be&scoped=true&"
import script from "./presentation-external-scrub.vue?vue&type=script&lang=js&"
export * from "./presentation-external-scrub.vue?vue&type=script&lang=js&"
import style0 from "./presentation-external-scrub.vue?vue&type=style&index=0&id=60f662be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f662be",
  null
  
)

export default component.exports